import { HeartHandshake, ArrowRight } from "lucide-react";

/**
 * Slim community-partnership strip inviting rural golf clubs, sports clubs,
 * schools and community groups to explore the Farm It Forward programme.
 * Kept low-intensity so it doesn't compete with the main download/CTA moment
 * above and below it.
 */
export default function GolfClubStrip() {
  return (
    <section
      aria-labelledby="golf-strip-heading"
      data-testid="golf-club-strip"
      className="bg-[#2D4A22] text-white"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-8 py-10 sm:py-12">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-start gap-4 max-w-2xl">
            <span
              aria-hidden
              className="hidden sm:inline-flex items-center justify-center w-12 h-12 flex-shrink-0 rounded-full bg-[#F2C76A]/20 border border-[#F2C76A]/40"
            >
              <HeartHandshake className="w-6 h-6 text-[#F2C76A]" strokeWidth={2.2} />
            </span>
            <div>
              <p className="text-xs font-bold tracking-[0.18em] uppercase text-[#F2C76A]">
                Farm It Forward
              </p>
              <h2
                id="golf-strip-heading"
                className="mt-2 font-display font-bold text-2xl sm:text-3xl leading-tight"
              >
                Fund your rural club, school or community group.
              </h2>
              <p className="mt-2 text-white/85 text-base leading-relaxed">
                Every session your members and families run through Arvo puts
                a slice back into your community — no bake sales required.
              </p>
            </div>
          </div>

          <a
            href="/farm-it-forward"
            data-testid="golf-strip-cta"
            className="inline-flex items-center gap-2 bg-[#F2C76A] hover:bg-[#E4B647] text-[#1A1D1A] font-bold px-6 py-3.5 rounded-md shadow-lg hover:-translate-y-0.5 transition-all whitespace-nowrap"
          >
            Tell me how it works <ArrowRight className="w-5 h-5" />
          </a>
        </div>
      </div>
    </section>
  );
}
